<template>
  <div v-if="bookingDetail && languageCode">
    <div class="row mt-3">
      <div class="col-md-12 content-list mb-2">
        <b>Booking Reference:</b>
        <span>{{ bookingDetail.bookingReference }}</span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Third Party Reference:</b>
        <span>{{ bookingDetail.thirdPartyBookingReference | noValue }}</span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Channel Name:</b>
        <span>{{ bookingDetail.channelName | noValue }}</span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Channel Type:</b>
        <span>{{ bookingDetail.channelTypeName | noValue }}</span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Booking Date:</b>
        <span>{{ localDateTime(bookingDetail.bookingDate) | formatDate }}</span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Total Order Value:</b>
        <span><strong>{{ $n(bookingDetail.bookingAmount, 'currency', languageCode) }}</strong></span>
      </div>
      <div class="col-md-12 content-list mb-2">
        <b>Status:</b>
        <span><strong>{{ fullStatus | splitPascal }}</strong></span>
      </div>
      <div
        v-if="$options.filters.formatDate(bookingDetail.amendmentDate) !== $options.filters.formatDate(bookingDetail.bookingDate)"
        class="col-md-12 content-list mb-2"
      >
        <b>Last Amendment Date:</b>
        <span><strong>{{ localDateTime(bookingDetail.amendmentDate) | formatDate }}</strong></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment-timezone'

export default {
    name: 'BookingDetail',
    computed: {
        ...mapState({
            bookingDetail: state => state.booking.bookingDetail
        }),
        ...mapGetters(['getSelectedAirportTimeZone']),
        fullStatus () {
            if (this.bookingDetail.status !== this.bookingDetail.subStatus) {
                return `${this.bookingDetail.status} (${this.bookingDetail.subStatus} )`
            }
            return this.bookingDetail.status
        },
        languageCode () {
            return this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
        }
    },
    created: function() {
        this.$store.dispatch('getBookingDetail', this.$route.params.bookingId)
    },
    methods:{
      localDateTime(dateTime) {
        var utcDateTime = moment.utc(dateTime.slice(0,16))
        var localDateTime = utcDateTime.tz(this.getSelectedAirportTimeZone).format('DD MMM YYYY HH:mm')
        return localDateTime
      }
    }
}
</script>

<style lang="scss" scoped>

</style>
